export default __webpack_public_path__ + "static/media/NetatmoOff.7a78f4e8.svg";